<template>
<div>AI导入</div>  
</template>

<script>
export default {

}
</script>

<style>

</style>